import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../api'
import {addBusinessDays} from "../../../util/functions";


const initialState = {
    displayComponent: "assignable",
    openDialog: false,
    actionType: "assign",
    rowSelection: {},
    completionDate: addBusinessDays(new Date(), 5).toISOString(),
    data: []
};

const manageContentSlice = createSlice({
    name: 'manageContent',
    initialState,
    reducers: {
        setDisplayComponent: (state, action) => { state.displayComponent = action.payload; },
        setOpenDialog: (state, action) => { state.openDialog = action.payload; },
        setActionType: (state, action) => { state.actionType = action.payload; },
        setRowSelection: (state, action) => { state.rowSelection = action.payload; },
        setCompletionDate: (state, action) => { state.completionDate = action.payload; },
        setApiResult: (state, { payload }) => { state.apiResult = payload; },
        clearRowData: (state) => { 
            state.result = undefined;
            state.apiResult = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                graphqlApi.endpoints.listAssignableApplications.matchFulfilled,
                (state, { payload }) => {
                    state.result = payload;
                }
            )
            .addMatcher(
                graphqlApi.endpoints.listAssignedApplications.matchFulfilled,
                (state, { payload }) => {
                    state.result = payload;
                }
            )
    }
});

export const {
    setDisplayComponent,
    setOpenDialog,
    setActionType,
    setRowSelection,
    setCompletionDate,
    setApiResult,
    clearRowData,
} = manageContentSlice.actions;

export const selectManageContent = (state) => state.manageContentSlice;

export default manageContentSlice.reducer;